import SuiTypography from "components/SuiTypography";
import Tooltip from "@mui/material/Tooltip";
import { globaleDateTimeFormatter } from "utils/helper";
import TableAction from "containers/table-action";
import { getFormattedClientName } from "utils/helper";
import { getUserLink } from "utils/helper";

const leadStatusStyle = (key) => {
  switch (key) {
    case "New":
      return "#3498db"; // Blue

    case "In Discussion":
      return "#f39c12"; // Orange

    case "Converted":
      return "#2ecc71"; // Green

    default:
      return "#e74c3c"; // Red
  }
};

export const leadRows_ = (
  leadArray,
  navigate,
  viewHandler,
  updateHandler,
  onDeleteHandler
) => {
  const getNoteText = (html) => {
    if (!html) return "N/A";
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "N/A";
  };

  const rows_ = leadArray.map((item, index) => {
    const mailLink = getUserLink(item.adminId, item.clientId || item.id);
    const customerNotes = getNoteText(item?.customerNotes);
    const latestConsultantNote =
      item?.consultantNotes?.length > 0
        ? getNoteText(
            item?.consultantNotes[item?.consultantNotes?.length - 1]
              ?.consultantNote
          )
        : "N/A";

    return {
      "S.no": (
        <SuiTypography
          variant="button"
          fontWeight="medium"
          style={{ paddingLeft: 14 }}
        >
          {index + 1}
        </SuiTypography>
      ),

      "Date/Time (Added)": (
        <SuiTypography variant="button" fontWeight="medium" style={{}}>
          {globaleDateTimeFormatter(item?.createdAt)}
        </SuiTypography>
      ),

      Name: (
        <SuiTypography
          variant="button"
          style={{
            color: "#17C1E8",
            cursor: "pointer",
          }}
          fontWeight="medium"
          onClick={() => {
            navigate(`/clients/${item.clientId || item.id}`);
          }}
        >
          {getFormattedClientName(item?.clientName)}
        </SuiTypography>
      ),
      Dietitian: (
        <SuiTypography variant="button" style={{}} fontWeight="medium">
          {item?.employee || "N/A"}
        </SuiTypography>
      ),

      "Ph. No.": (
        <SuiTypography variant="button" style={{}} fontWeight="medium">
          {item?.phoneNumber}
        </SuiTypography>
      ),

      Email: (
        <SuiTypography variant="button" style={{}} fontWeight="medium">
          {item?.email}
        </SuiTypography>
      ),

      "Customer Notes": (
        <Tooltip title={customerNotes} placement="top">
          <SuiTypography variant="button" fontWeight="medium" style={{}}>
            {customerNotes.length > 20
              ? `${customerNotes.slice(0, 20)}...`
              : customerNotes}
          </SuiTypography>
        </Tooltip>
      ),

      "Consultant Notes (Latest)": (
        <Tooltip title={latestConsultantNote} placement="top">
          <SuiTypography variant="button" fontWeight="medium" style={{}}>
            {latestConsultantNote.length > 20
              ? `${latestConsultantNote.slice(0, 20)}...`
              : latestConsultantNote}
          </SuiTypography>
        </Tooltip>
      ),

      Status: (
        <SuiTypography
          variant="button"
          style={{ color: leadStatusStyle(item?.status) }}
          fontWeight="medium"
        >
          {item?.status}
        </SuiTypography>
      ),

      "Service Interested In": (
        <SuiTypography style={{}} variant="button" fontWeight="medium">
          {item?.service}
        </SuiTypography>
      ),

      Source: (
        <SuiTypography variant="button" style={{}} fontWeight="medium">
          {item?.source}
        </SuiTypography>
      ),

      "Referred by": (
        <SuiTypography variant="button" style={{}} fontWeight="medium">
          {item?.referredBy ?? "N/A"}
        </SuiTypography>
      ),

      "Next follow up date": (
        <SuiTypography variant="button" style={{}} fontWeight="medium">
          {globaleDateTimeFormatter(item?.followUpDate, "date")}
        </SuiTypography>
      ),

      Action: (
        <TableAction
          iconStyle={{}}
          style={{ padding: "3px", marginLeft: "5px" }}
          mailLink={mailLink}
          updateHandler={() => updateHandler(item)}
          viewHandler={() => viewHandler(item)}
          deleteHandler={() => onDeleteHandler(item)}
        />
      ),
    };
  });
  return rows_;
};
